import React, { ReactElement, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

type TabContentItem = {
  id?: number
  label: string | undefined
  component: ReactElement
  /** 들어가도 볼 게 없는 탭을 막는다. 안 넘기면 예전처럼 전부 활성이다. */
  disabled?: boolean
}

type TabContentsType = TabContentItem[];

type Props = {
  tabs: TabContentsType
}

export const TabContents = ({ tabs }: Props) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // 보고 있던 탭이 뒤늦게 막히는 경우가 있다. 예를 들어 수수료 탭을 열어둔 채로
  // 보수 이력이 없는 다른 펀드를 고르면 그렇다. MUI 는 선택값을 알아서 옮겨주지
  // 않아서, 탭은 회색인데 그 아래 내용은 그대로 떠 있게 된다. 살아있는 첫 탭으로
  // 옮긴다. 전부 막혀 있으면 0 을 다시 넣는데, 같은 값이라 리렌더는 멈춘다.
  const activeDisabled = Boolean(tabs?.[value]?.disabled);
  useEffect(() => {
    if (!activeDisabled) return;
    const next = tabs.findIndex((item) => !item.disabled);
    setValue(next === -1 ? 0 : next);
  }, [activeDisabled, tabs]);

  return (
    <>
      <Box
        sx={{
          display: "inline-block",
          borderBottom: 1,
          borderColor: "divider",
          width: "100%",
        }}
      >
        <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto" aria-label="scrollable auto tabs example">
          {tabs?.map((item, index) => (
            <Tab label={item.label} key={index} disabled={item.disabled} />
          ))}
        </Tabs>
      </Box>
      {tabs?.map((item, index) => (
        <TabPanel value={value} index={index} key={index}>
          {item.component}
        </TabPanel>
      ))}
    </>
  );
};

const TabPanel = ({ children, value, index, ...other }) => (
  <Box
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
  </Box>
);

export function simpeTabProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default TabPanel;
